<template>
  <div v-if="isI18nLoaded" :class="customClass">
    <slot name="header">
      <h1 v-if="component">{{ component.name }} Component Test-Suite:</h1>
    </slot>
    <slot name="tests" :items="tests" :listeners="$listeners">
      <template v-for="n in cnt">
        <slot name="item" :n="n" :test="getTest(n)" :toggle="toggle" :component="component" :listeners="$listeners">
          <h3
            >Test #{{ n }}: <small>{{ getTest(n).description }}</small></h3
          >
          <component :is="component" v-bind="getTest(n)" v-on="$listeners" />
        </slot>
        <slot name="toggle" :n="n" :test="getTest(n)" :toggle="toggle">
          <a href="#" style="position: relative; top: 16px; font-size: 10pt;" @click.prevent="$set(toggle, n, !toggle[n])">Toggle details</a>
          <pre v-if="toggle[n]">{{ JSON.stringify(getTest(n), null, 2) }}</pre>
        </slot>
        <slot name="separator" :n="n">
          <hr />
        </slot>
      </template>
    </slot>

    <div class="container-fixed">
      <label>
        <h3>Sandbox:</h3>
        <textarea v-model="customInput" class="form-input" style="height: 500px; margin-bottom: 12px;"></textarea>
      </label>
      <button class="btn btn-default" @click.prevent="customObject = JSON.parse(customInput)">Apply</button>

      <h4><small>Result:</small></h4>
      <slot v-if="customObject" name="sandbox" :customObject="customObject">
        <component :is="component" v-bind="customObject" />
      </slot>
    </div>
  </div>
</template>

<script>
/* eslint vue/require-v-for-key: 0 */

import merge from 'lodash/merge';

export default {
  name: 'CommonguiTest',

  inheritAttrs: false,

  props: {
    defaultTest: {
      type: Object,
      required: true,
    },

    testDiffs: {
      type: Array,
      required: true,
    },

    component: {
      type: Object,
      required: false,
      default: null,
    },

    i18n: {
      type: String,
      required: false,
      default: 'common',
    },

    customClass: {
      type: String,
      required: false,
      default: 'container-fixed',
    },
  },

  data() {
    return {
      toggle: {},
      customObject: null,

      // will get initialized by created hook:
      customInput: '',
      tests: [],
    };
  },

  computed: {
    cnt() {
      return this.tests.length;
    },

    isI18nLoaded() {
      return !!this.$i18n.messages.de[this.i18n];
    },
  },

  created() {
    this.customInput = JSON.stringify(this.defaultTest, null, 2);
    this.testDiffs.forEach(test => {
      this.tests.push(merge({}, this.defaultTest, test));
    });
  },

  methods: {
    getTest(n) {
      return {
        'data-test': `test_${n}`,
        ...this.tests[n - 1],
      };
    },
  },
};
</script>
